export default function (data) {
  var self = this;
  self.$el = $('#survey_detail');

  self.survey = ko.observable();
  self.paginator = ko.observable();
  self.charts = [];

  self.questions = ko.observableArray();
  self.selected_question = ko.observable();
  self.selected_question.subscribe(function(value) {
    $('html, body').animate({scrollTop: $('#question_' + value).offset().top + 'px'}, 'slow');
  });

  self.initUI = function() { // called after all questions are finished
    self.refreshCharts();
    $(window).resize(function(){
      self.refreshCharts();
    });
    Kadenze.UIUtil.initDotDotDotTruncation();
    Kadenze.UIUtil.initJumpNav();
  };

  self.initQuestionUI = function(element, item) { // called for each question
    var $question = $(element);
    var $chart, surveyChart;

    if(item._type() == 'RatingField' || item._type() == 'MatrixField') {
      if (item._type() == 'MatrixField' && !item.rating_scale()) {
        var yLbl = item.multi_response() ? 'Responses' : 'No. of Students';
        _.each(item.answer_groups(), function (group, index) {
          $chart = $(('.js-barchart#group-' + index), $question);
          surveyChart = new Kadenze.Chart.GroupedBarChart($chart[0], '', yLbl, ko.mapping.toJS(group));
          self.charts.push(surveyChart);
        });
      } else {
        $chart = $('.js-barchart', $question);
        var $chartDataTable = $('.chart-data', $question);
        var xlabel = $('th.x', $chartDataTable).text();
        var ylabel = $('th.y', $chartDataTable).text();
        surveyChart = new Kadenze.Chart.BarChart($chart[0], xlabel, ylabel, ko.mapping.toJS(item.answers));
        self.charts.push(surveyChart);
      }
    } else if (item._type() == 'MultipleChoiceField' || item._type() == 'TrueFalseField') {
      self.setRingChartHolderHeight();
      $chart = $('.js-ringchart', $question);
      surveyChart = new Kadenze.Chart.RingChart($chart[0], ko.mapping.toJS(item.answers), 'Results');
      self.charts.push(surveyChart);
    }
  };

  self.setRingChartHolderHeight = function(){
    var width = $('.js-ringchart').width();
    var height = Math.min( Math.max( (width * 0.6),250 ), 600);
    $('.js-ringchart').height(height);
  };


  self.refreshCharts = function() {
    self.setRingChartHolderHeight();
    for(var i = 0; i < self.charts.length; i++) {
      var target = self.charts[i];
      target.refresh();
    }
  };

  self.getCourseworkFieldTemplate = function(type) {
    return 'survey_' + Kadenze.Util.snakeCase(type);
  };

  self.getQuestionIndex = function(item) {
    var index = self.survey().questions.indexOf(item);
    return (index + 1);
  };

  self.bindData = function(data) {
    self.paginator(data.paginator);

    var mapped_surveys = ko.mapping.fromJS(data);
    self.survey(mapped_surveys);
  };

  const __construct = function(that) {
    that.course_id = $('#course_id').val();
    console.log('constructor called for CourseSurveyDetailViewModel');
    that.bindData(data);
  }(this);
}


